<!-- Template: App Root (app.html)
     Purpose: global shell with the loading bar, the routed pages and the toast container. -->
<!-- Global loading bar for HTTP requests and router events -->
<ngx-loading-bar></ngx-loading-bar>

<!-- Routed pages (authorization / login and the authenticated layout) -->
<router-outlet />

<!-- Global toast container for notifications (via ToastManager) -->
<p-toast></p-toast>
